// extracted by mini-css-extract-plugin
export default {"emptyState":"SearchResultsEmptyState_emptyState__OvyyM","resetBtn":"SearchResultsEmptyState_resetBtn__YyI8H"};